import { useRef } from 'react';

import styles from './styles.module.scss';
import UpIcon from './UpIcon';

function Fab() {
  const ref = useRef<HTMLButtonElement>(null);
  const scrollToTop = () => {
    const container = ref.current?.parentElement?.parentElement;
    container?.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
        <button className={styles.button}
                ref={ref}
                onClick={scrollToTop}>
            <UpIcon/>
        </button>
  );
}

export default Fab;
